import { useState, useEffect, useCallback, useRef } from 'react';

/**
 * Background images per theme - VERIFIED UMBRIA LOCATIONS ONLY
 * Each image is from actual Umbrian locations to ensure brand authenticity
 */
const BACKGROUND_IMAGES = {
  umbria_general: [
    // Assisi - Basilica di San Francesco
    'https://images.unsplash.com/photo-1607727729519-9643c7f22916?w=1920&q=80',
    // Spoleto - Duomo
    'https://images.unsplash.com/photo-1595366614695-3b6f5e1019b3?w=1920&q=80',
    // Monteleone di Spoleto aerial
    'https://images.pexels.com/photos/10804675/pexels-photo-10804675.jpeg?w=1920&q=80',
    // Orvieto Cathedral detail
    'https://images.unsplash.com/photo-1595200277936-9aac7a8abf12?w=1920&q=80',
    // Trasimeno Lake with island
    'https://images.unsplash.com/photo-1609881142770-5ee704f50b6a?w=1920&q=80',
    // Umbria olive groves
    'https://images.pexels.com/photos/17835461/pexels-photo-17835461.jpeg?w=1920&q=80',
  ],
  wine_food: [
    // Vineyard with mountains (Umbria style)
    'https://images.pexels.com/photos/28302113/pexels-photo-28302113.jpeg?w=1920&q=80',
    // Wine picnic in vineyard
    'https://images.pexels.com/photos/19065410/pexels-photo-19065410.jpeg?w=1920&q=80',
    // Olive grove Umbria hills
    'https://images.pexels.com/photos/17835461/pexels-photo-17835461.jpeg?w=1920&q=80',
    // Spoleto historic center
    'https://images.unsplash.com/photo-1595366999173-e7cabe9969b5?w=1920&q=80',
    // Orvieto cathedral facade
    'https://images.unsplash.com/photo-1595200788860-2cbcc3285b94?w=1920&q=80',
    // Trasimeno sunset
    'https://images.pexels.com/photos/9999857/pexels-photo-9999857.jpeg?w=1920&q=80',
  ],
  biking: [
    // Umbria countryside hills
    'https://images.pexels.com/photos/15625312/pexels-photo-15625312.jpeg?w=1920&q=80',
    // Trasimeno lake view
    'https://images.unsplash.com/photo-1609881143129-3127890a7803?w=1920&q=80',
    // Monteleone di Spoleto
    'https://images.pexels.com/photos/10804675/pexels-photo-10804675.jpeg?w=1920&q=80',
    // Olive trees hillside
    'https://images.pexels.com/photos/17835461/pexels-photo-17835461.jpeg?w=1920&q=80',
    // Spoleto architecture
    'https://images.unsplash.com/photo-1595366614695-3b6f5e1019b3?w=1920&q=80',
    // Vineyard rows
    'https://images.pexels.com/photos/28302113/pexels-photo-28302113.jpeg?w=1920&q=80',
  ],
  hiking: [
    // Castelluccio poppies field
    'https://images.pexels.com/photos/35591028/pexels-photo-35591028.jpeg?w=1920&q=80',
    // Umbria hills olive trees
    'https://images.pexels.com/photos/15625312/pexels-photo-15625312.jpeg?w=1920&q=80',
    // Trasimeno reflection
    'https://images.unsplash.com/photo-1609881142760-298c2e76725b?w=1920&q=80',
    // Monteleone aerial
    'https://images.pexels.com/photos/10804675/pexels-photo-10804675.jpeg?w=1920&q=80',
    // Olive groves
    'https://images.pexels.com/photos/17835461/pexels-photo-17835461.jpeg?w=1920&q=80',
    // Spoleto duomo
    'https://images.unsplash.com/photo-1595366614695-3b6f5e1019b3?w=1920&q=80',
  ],
  borghi: [
    // Monteleone di Spoleto aerial
    'https://images.pexels.com/photos/10804675/pexels-photo-10804675.jpeg?w=1920&q=80',
    // Spoleto duomo piazza
    'https://images.unsplash.com/photo-1595366614695-3b6f5e1019b3?w=1920&q=80',
    // Orvieto cathedral
    'https://images.unsplash.com/photo-1595200277936-9aac7a8abf12?w=1920&q=80',
    // Assisi basilica
    'https://images.unsplash.com/photo-1607727729519-9643c7f22916?w=1920&q=80',
    // Orvieto facade detail
    'https://images.unsplash.com/photo-1595200788860-2cbcc3285b94?w=1920&q=80',
    // Assisi church view
    'https://images.unsplash.com/photo-1671128913822-8ac66a2af629?w=1920&q=80',
  ],
  assisi_spiritual: [
    // Assisi Basilica San Francesco
    'https://images.unsplash.com/photo-1607727729519-9643c7f22916?w=1920&q=80',
    // Assisi church with person
    'https://images.unsplash.com/photo-1635524359619-8c1350d4e809?w=1920&q=80',
    // Assisi building with tower
    'https://images.unsplash.com/photo-1671128913822-8ac66a2af629?w=1920&q=80',
    // Spoleto duomo
    'https://images.unsplash.com/photo-1595366614695-3b6f5e1019b3?w=1920&q=80',
    // Orvieto cathedral
    'https://images.unsplash.com/photo-1595200277936-9aac7a8abf12?w=1920&q=80',
    // Olive tree detail
    'https://images.unsplash.com/photo-1595366999173-e7cabe9969b5?w=1920&q=80',
  ],
  truffle: [
    // Umbria forest/hills
    'https://images.pexels.com/photos/15625312/pexels-photo-15625312.jpeg?w=1920&q=80',
    // Olive groves
    'https://images.pexels.com/photos/17835461/pexels-photo-17835461.jpeg?w=1920&q=80',
    // Castelluccio landscape
    'https://images.pexels.com/photos/35591028/pexels-photo-35591028.jpeg?w=1920&q=80',
    // Monteleone village
    'https://images.pexels.com/photos/10804675/pexels-photo-10804675.jpeg?w=1920&q=80',
    // Spoleto
    'https://images.unsplash.com/photo-1595366999173-e7cabe9969b5?w=1920&q=80',
    // Trasimeno
    'https://images.unsplash.com/photo-1609881142770-5ee704f50b6a?w=1920&q=80',
  ],
  lake: [
    // Trasimeno island panorama
    'https://images.unsplash.com/photo-1609881142770-5ee704f50b6a?w=1920&q=80',
    // Trasimeno reflection
    'https://images.unsplash.com/photo-1609881143129-3127890a7803?w=1920&q=80',
    // Trasimeno hills view
    'https://images.unsplash.com/photo-1609881142760-298c2e76725b?w=1920&q=80',
    // Trasimeno peaceful view
    'https://images.pexels.com/photos/32534417/pexels-photo-32534417.jpeg?w=1920&q=80',
    // Trasimeno sunset boats
    'https://images.pexels.com/photos/9999857/pexels-photo-9999857.jpeg?w=1920&q=80',
    // Umbria countryside
    'https://images.pexels.com/photos/17835461/pexels-photo-17835461.jpeg?w=1920&q=80',
  ],
  artisan: [
    // Spoleto detail
    'https://images.unsplash.com/photo-1595366999173-e7cabe9969b5?w=1920&q=80',
    // Orvieto cathedral detail
    'https://images.unsplash.com/photo-1595200277936-9aac7a8abf12?w=1920&q=80',
    // Orvieto facade
    'https://images.unsplash.com/photo-1595200788860-2cbcc3285b94?w=1920&q=80',
    // Monteleone architecture
    'https://images.pexels.com/photos/10804675/pexels-photo-10804675.jpeg?w=1920&q=80',
    // Assisi
    'https://images.unsplash.com/photo-1635524359619-8c1350d4e809?w=1920&q=80',
    // Spoleto piazza
    'https://images.unsplash.com/photo-1595366614695-3b6f5e1019b3?w=1920&q=80',
  ],
  family: [
    // Trasimeno lake calm
    'https://images.unsplash.com/photo-1609881142770-5ee704f50b6a?w=1920&q=80',
    // Umbria countryside
    'https://images.pexels.com/photos/17835461/pexels-photo-17835461.jpeg?w=1920&q=80',
    // Castelluccio poppies
    'https://images.pexels.com/photos/35591028/pexels-photo-35591028.jpeg?w=1920&q=80',
    // Trasimeno peaceful
    'https://images.pexels.com/photos/32534417/pexels-photo-32534417.jpeg?w=1920&q=80',
    // Monteleone village
    'https://images.pexels.com/photos/10804675/pexels-photo-10804675.jpeg?w=1920&q=80',
    // Olive groves
    'https://images.pexels.com/photos/15625312/pexels-photo-15625312.jpeg?w=1920&q=80',
  ],
  night: [
    // Trasimeno sunset
    'https://images.pexels.com/photos/9999857/pexels-photo-9999857.jpeg?w=1920&q=80',
    // Monteleone evening
    'https://images.pexels.com/photos/10804675/pexels-photo-10804675.jpeg?w=1920&q=80',
    // Spoleto duomo
    'https://images.unsplash.com/photo-1595366614695-3b6f5e1019b3?w=1920&q=80',
    // Orvieto
    'https://images.unsplash.com/photo-1595200277936-9aac7a8abf12?w=1920&q=80',
    // Assisi
    'https://images.unsplash.com/photo-1607727729519-9643c7f22916?w=1920&q=80',
    // Trasimeno reflection
    'https://images.unsplash.com/photo-1609881143129-3127890a7803?w=1920&q=80',
  ],
};

// Timing constants
const CROSSFADE_DURATION_MS = 1000;
const ROTATION_INTERVAL_MS = 45000; // 45 seconds within same theme

/**
 * DynamicBackground with smooth crossfade transitions
 * 
 * Props:
 * - themeKey: Current stable theme from ThemeSignalExtractor
 * - phase: Conversation phase (DISCOVERY, DRAFT, ITINERARY)
 * - children: Content to render over background
 */
export const DynamicBackground = ({ 
  themeKey = 'umbria_general', 
  phase = 'DISCOVERY',
  children 
}) => {
  // Currently displayed theme and image
  const [displayedTheme, setDisplayedTheme] = useState(themeKey);
  const [imageIndex, setImageIndex] = useState(0);
  
  // Crossfade state: two layers with opacity toggle
  const [layer1Url, setLayer1Url] = useState('');
  const [layer2Url, setLayer2Url] = useState('');
  const [showLayer1, setShowLayer1] = useState(true);
  
  // Preload cache
  const preloadedRef = useRef(new Set());
  const rotationTimerRef = useRef(null);
  
  // Get images for a theme
  const getThemeImages = useCallback((theme) => {
    return BACKGROUND_IMAGES[theme] || BACKGROUND_IMAGES.umbria_general;
  }, []);
  
  // Preload an image
  const preloadImage = useCallback((url) => {
    return new Promise((resolve) => {
      if (preloadedRef.current.has(url)) {
        resolve(url);
        return;
      }
      const img = new Image();
      img.onload = () => {
        preloadedRef.current.add(url);
        resolve(url);
      };
      img.onerror = () => resolve(url);
      img.src = url;
    });
  }, []);
  
  // Initialize on mount
  useEffect(() => {
    const images = getThemeImages(themeKey);
    const firstImage = images[0];
    
    preloadImage(firstImage).then(() => {
      setLayer1Url(firstImage);
      setLayer2Url(firstImage);
      setDisplayedTheme(themeKey);
    });
    
    // Preload more images
    images.slice(1, 3).forEach(preloadImage);
  }, []); // Mount only
  
  // Handle theme change with crossfade
  useEffect(() => {
    if (themeKey === displayedTheme) return;
    if (!layer1Url) return; // Not initialized
    
    const images = getThemeImages(themeKey);
    const newImage = images[0];
    
    preloadImage(newImage).then(() => {
      // Set new image on hidden layer
      if (showLayer1) {
        setLayer2Url(newImage);
      } else {
        setLayer1Url(newImage);
      }
      
      // Toggle layers to crossfade
      setShowLayer1(prev => !prev);
      
      // Update state after transition
      setTimeout(() => {
        setDisplayedTheme(themeKey);
        setImageIndex(0);
      }, CROSSFADE_DURATION_MS);
    });
    
    // Preload next images in new theme
    images.slice(1, 3).forEach(preloadImage);
  }, [themeKey, displayedTheme, showLayer1, layer1Url, getThemeImages, preloadImage]);
  
  // Rotation within theme
  useEffect(() => {
    const images = getThemeImages(displayedTheme);
    if (images.length <= 1) return;
    
    rotationTimerRef.current = setInterval(() => {
      setImageIndex(prev => {
        const nextIndex = (prev + 1) % images.length;
        const nextImage = images[nextIndex];
        
        preloadImage(nextImage).then(() => {
          if (showLayer1) {
            setLayer2Url(nextImage);
          } else {
            setLayer1Url(nextImage);
          }
          setShowLayer1(s => !s);
        });
        
        return nextIndex;
      });
    }, ROTATION_INTERVAL_MS);
    
    return () => {
      if (rotationTimerRef.current) {
        clearInterval(rotationTimerRef.current);
      }
    };
  }, [displayedTheme, getThemeImages, preloadImage, showLayer1]);

  return (
    <div className="relative min-h-screen overflow-hidden" data-testid="dynamic-background">
      {/* Layer 1 */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity"
        style={{ 
          backgroundImage: layer1Url ? `url(${layer1Url})` : 'none',
          opacity: showLayer1 ? 1 : 0,
          transitionDuration: `${CROSSFADE_DURATION_MS}ms`,
          transitionTimingFunction: 'ease-in-out'
        }}
        aria-hidden="true"
      />
      
      {/* Layer 2 */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity"
        style={{ 
          backgroundImage: layer2Url ? `url(${layer2Url})` : 'none',
          opacity: showLayer1 ? 0 : 1,
          transitionDuration: `${CROSSFADE_DURATION_MS}ms`,
          transitionTimingFunction: 'ease-in-out'
        }}
        aria-hidden="true"
      />
      
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40 pointer-events-none" />
      
      {/* Content */}
      <div className="relative z-10 min-h-screen">
        {children}
      </div>
    </div>
  );
};

export default DynamicBackground;
